import React from "react";
import { Route, Router, Switch } from "wouter";

import BidSelfServe from "components/account_management/qualification-criteria/BidSelfServe";
import { BidDocumentUploadPage } from "components/bid_module/BidDocumentUploadPage";
import { BidModuleCustomHeader } from "components/bid_module/BidModuleExternalHeader";
import { BidNoBidPage } from "components/bid_module/BidNoBidPage";
import { BidWritingQuestionsPage } from "components/bid_module/BidWritingQuestionsPage";
import { MyBidsTable } from "components/bid_module/MyBidsTable";
import { withAppLayout } from "../../components/app_layout/AppLayout";
import { DetailsContent } from "../../components/app_layout/DetailsLayout";
import { Flex, Text } from "../../styles/utility-components";

import css from "./MyBidsPage.module.scss";

function MyBidsPageWrapper() {
  return (
    <Router base="/bids">
      <Switch>
        <Route path="/:id/bid-self-serve" component={BidSelfServe} />
        <Route path="/:id/bid-qualification">{(_params) => <BidNoBidPage />}</Route>
        <Route path="/:id?/bid-writing-questions">{(_params) => <BidWritingQuestionsPage />}</Route>
        <Route path="/bid-upload">{(_params) => <BidDocumentUploadPage />}</Route>
        <Route path="/" component={MyBidsPage} />
      </Switch>
    </Router>
  );
}

function MyBidsPage() {
  return (
    <DetailsContent className={css.container}>
      <Flex column gap={24}>
        <Flex column gap={8}>
          <Text h2>Bid / no-bid reports</Text>
          <Text color="sysTextSecondary">Displaying all bid / no-bid reports</Text>
        </Flex>
        <MyBidsTable />
      </Flex>
    </DetailsContent>
  );
}

export default withAppLayout(MyBidsPageWrapper, {
  displayCustomAction: !window.currentUser &&
    window.location.href.includes("bid_qualification") && <BidModuleCustomHeader />,
});
